import type { IconProp } from '@fortawesome/fontawesome-svg-core'
import type { Dispatch, SetStateAction } from 'react'
import { faBars, faMoon, faSun } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { toast } from 'react-toastify'
import { DarkModeContext } from '../../../providers/DarkModeProvider'
import { useUser } from '../../../providers/UserProvider'
import { stopMasquerade } from '../../../services/auth.service'
import UserDropdown from './user-dropdown/UserDropdown'
import './Header.css'

interface HeaderProps {
  sidebar: {
    get: boolean
    set: Dispatch<SetStateAction<boolean>>
  }
}

function Header(props: HeaderProps) {
  const { id, user, masqueradedBy } = useUser()

  // Red header on development, blue in production, so the two are told apart at a glance;
  // yellow while masquerading as another user, so nobody forgets whose account this is.
  const isDev = process.env.NODE_ENV === 'development'
  const navbarVariant = masqueradedBy ? 'bg-warning navbar-masquerade' : isDev ? 'bg-danger' : 'bg-primary'

  const { isDarkMode, toggleDarkMode } = React.useContext(DarkModeContext)

  const backToOwnAccount = async () => {
    try {
      await stopMasquerade()
      // A full reload, so nothing cached under the masqueraded identity survives
      window.location.assign(`/settings/toegang/gebruikers/${id}`)
    }
    catch (error) {
      toast.error((error as Error).message)
    }
  }

  return (
    <nav className={`app-header navbar navbar-expand navbar-accent border-bottom-0 ${navbarVariant}`}>
      <div className="container-fluid">
        <ul className="navbar-nav">
          <li className="nav-item">
            <button
              onClick={() => props.sidebar.set(prev => !prev)}
              type="button"
              className="nav-link"
            >
              <FontAwesomeIcon icon={faBars as IconProp} />
            </button>
          </li>
          <li className="nav-item">
            <button
              onClick={toggleDarkMode}
              type="button"
              className="nav-link"
            >
              {isDarkMode
                ? (
                    <FontAwesomeIcon icon={faSun as IconProp} />
                  )
                : (
                    <FontAwesomeIcon icon={faMoon as IconProp} />
                  )}
            </button>
          </li>
        </ul>
        <ul className="navbar-nav ms-auto">
          {masqueradedBy && (
            <li className="nav-item d-flex align-items-center gap-2 me-2">
              <span className="navbar-text d-none d-md-inline">
                Ingelogd als
                {' '}
                {user.firstName}
                {' '}
                {user.lastName}
              </span>
              <button type="button" className="btn btn-sm btn-dark" onClick={backToOwnAccount}>
                Terug naar mijn account
              </button>
            </li>
          )}
          <UserDropdown />
        </ul>
      </div>
    </nav>
  )
}

export default Header
